import CTA from "../CTA/CTA";
import s from "./Header.module.scss";


const Header = () => {

    return (
        <header>
            <nav>
                <a className={s.logo} href="#">
                    <img src="/atelier-de-la-villette/assets/logo_Villette.jpg" alt="Atelier de la Villette. Aller à l'accueil" />
                </a>
                <CTA
                    variant="icon"
                    text="Je demande un devis"
                    href="https://www.avh.asso.fr/implantations/latelier-de-la-villette/devis"
                    icon={<img src="/atelier-de-la-villette/assets/icon/devis.png" alt="" />}
                />
            </nav>
        </header>
    )
}

export default Header;